import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="bg-background-50 py-16 md:py-24" id="categories">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-12">
          <div className="flex-1">
            <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 leading-tight">
              Shop by
              <br />
              Category
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md lg:text-right">
            Browse our complete collection of product categories — each linked to
            organized Kakobuy spreadsheet lists for fast product discovery.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] ${
                idx === 0
                  ? 'bg-primary-800 sm:col-span-1'
                  : 'bg-background-100'
              }`}
            >
              {idx === 0 ? (
                <div className="p-6 md:p-8 h-full min-h-[200px] flex flex-col justify-end">
                  <h3 className="text-xl md:text-2xl font-heading text-background-50 mb-2">{cat.name}</h3>
                  <p className="text-sm text-background-50/60 mb-4">Discover trending footwear collections</p>
                  <span className="inline-flex items-center gap-1.5 text-sm font-medium text-background-50 bg-background-50/10 px-4 py-2 rounded-full w-fit group-hover:bg-background-50/20 transition-colors">
                    Browse <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              ) : (
                <div className="p-5 md:p-6 h-full min-h-[180px] flex flex-col justify-between">
                  <div>
                    <span className="inline-flex items-center gap-1 text-xs text-accent-600 bg-accent-100/70 px-2.5 py-1 rounded-full mb-3">
                      <i className="ri-price-tag-3-line"></i> Popular
                    </span>
                    <h3 className="text-lg md:text-xl font-heading text-foreground-900 mb-1">{cat.name}</h3>
                    <p className="text-xs text-foreground-500">Curated spreadsheet collection</p>
                  </div>
                  <span className="inline-flex items-center gap-1.5 text-xs font-medium text-background-50 bg-primary-500 px-3.5 py-2 rounded-full w-fit mt-3 group-hover:bg-primary-600 transition-colors">
                    Browse <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}